import { GridScorecard } from "@/grid/components/GridScorecard";
import { Navigate, useParams } from "react-router-dom";
import { isDepartmentId } from "@/grid/config/registry";

export function GridPage() {
  const { departmentId = "sales" } = useParams<{ departmentId: string }>();

  if (!isDepartmentId(departmentId)) {
    return <Navigate to="/grid/sales" replace />;
  }

  return <GridScorecard departmentId={departmentId} />;
}
